export default __webpack_public_path__ + "static/media/UBCwellbeing.bd4451b7.png";